import CitySetting from "./KrCitySetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrCitySetting = install(CitySetting); // 生成带有 install 方法的组件

export default KrCitySetting;
